module.exports = "<div class=\"dropdown-item_name _optionText\" data-value=\"{{::option.Name}} {{::option.AddressLine1}}, {{::option.Suburb}}\">\r\n    <span>{{option.AddressLine1}}, {{option.Suburb}}</span>\r\n    <span ng-if=\"option.Distance.length > 0\" class=\"dropdown-item_distance pull-right\">{{option.Distance}} km</span>\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/shoplocator/shop-locator-search-postcode-template.html
 ** module id = 1009
 ** module chunks = 1
 **/